var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#050708",
    opacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.811 10s.409 1.904-.798 3.133-2.978 1.395-2.978 1.395-.188-1.867.946-3.05c1.136-1.18 2.83-1.478 2.83-1.478m3.672 6.75s-2.603 1.609-2.058 4.35c.545 2.743 2.65 3.427 2.65 3.427s-1.135 3.051-2.389 4.115c-1.25 1.064-1.632 1.348-2.718 1.042a9 9 0 0 1-.948-.341c-.623-.254-1.181-.48-1.938-.368-.506.076-.972.259-1.418.434-.532.209-1.034.406-1.537.393-.922-.023-2.223-.85-3.5-3.05-1.276-2.199-1.938-5.036-1.63-7.259.306-2.222 2.004-4.084 3.617-4.491 1.487-.376 2.392.011 3.17.344.446.191.85.365 1.298.365 0 0 .425 0 1.277-.356q.112-.046.225-.095c.782-.336 1.628-.698 3.18-.353 1.705.377 2.719 1.844 2.719 1.844",
    clipRule: "evenodd"
  })));
};
export default SvgApple;